import PropTypes from 'prop-types';
import styled from 'styled-components';
import LibAccordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

import { theme } from '_constants/theme';

const StyledContainer = styled.div``;

const StyledHeader = styled.div`
  display: flex;
  cursor: pointer;
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${theme.spaces.smallX}px;
`;

const StyledTitle = styled.div`
  flex-grow: 1;
`;

const StyledBody = styled.div``;

const AccordionItem = ({
  eventKey,
  title,
  children,
  open,
  openIcon,
  closeIcon,
  onToggle,
}) => {
  const handleToggle = useAccordionButton(
    eventKey,
    () => onToggle && onToggle(eventKey)
  );

  return (
    <StyledContainer>
      <StyledHeader onClick={handleToggle}>
        <StyledTitle>{title}</StyledTitle>
        <StyledIconContainer>{open ? openIcon : closeIcon}</StyledIconContainer>
      </StyledHeader>
      <LibAccordion.Collapse eventKey={eventKey}>
        <StyledBody>{children}</StyledBody>
      </LibAccordion.Collapse>
    </StyledContainer>
  );
};

AccordionItem.propTypes = {
  eventKey: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  open: PropTypes.bool,
  openIcon: PropTypes.node,
  closeIcon: PropTypes.node,
  onToggle: PropTypes.func,
};

export default AccordionItem;
